module.exports = __webpack_public_path__ + "img/Tessellate36.ae79687b.jpg";